/**
 * PDP color picker — show selected color name in the fieldset legend.
 */
(function () {
  function updateColorLegend(fieldset) {
    var checked = fieldset.querySelector('input[type="radio"]:checked');
    var label = fieldset.querySelector('.aaf-pdp-option-value');
    if (!checked || !label) return;
    label.textContent = checked.value;
  }

  function initPicker(picker) {
    picker
      .querySelectorAll('.product-form__input--color, .product-form__input--colour')
      .forEach(function (fieldset) {
        updateColorLegend(fieldset);
        fieldset.addEventListener('change', function () {
          updateColorLegend(fieldset);
        });
      });
  }

  function init() {
    document.querySelectorAll('variant-radios').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();